import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SupplyChain from "./usecase/supplychain/SupplyChain";
import Esg from "./usecase/esg/Esg";
import DigitalProducts from "./usecase/digitalProducts/DigitalProducts";
import Notarialization from "./usecase/notarialization/Notarialization";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/supplychain/*" element={<SupplyChain />} />

        <Route path="/esg-reporting/*" element={<Esg />} />

        <Route path="/dpp/*" element={<DigitalProducts />} />

        <Route path="/notarisation/*" element={<Notarialization />} />
      </Routes>
    </Router>
  );
}

export default App;
